import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import './styles/theme.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { initTheme, getCurrentTheme, themes } from './utils/themeService'

const themeConfig = {
  modern: {
    // 现代简约 - 墨绿
    global: {
      colorPrimary: '#1B4D3E'
    },
    token: {
      colorPrimary: '#1B4D3E',
      colorSuccess: '#67C23A',
      colorWarning: '#E6A23C',
      colorDanger: '#F56C6C',
      colorInfo: '#909399'
    }
  }
};

// 添加全局错误处理
window.addEventListener('error', (event) => {
  if (event.message.includes('SyntaxError: "undefined" is not valid JSON')) {
    console.error('捕获到JSON解析错误，正在重置localStorage...');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token');
    localStorage.removeItem('theme');
    window.location.reload();
  }
});

const app = createApp(App)
const pinia = createPinia()

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, {
  locale: zhCn
})
app.use(pinia)
app.use(router)

initTheme()

app.mount('#app')
